import { render, staticRenderFns } from "./HighSchool.vue?vue&type=template&id=1747a8fc&scoped=true"
import script from "./HighSchool.vue?vue&type=script&lang=js"
export * from "./HighSchool.vue?vue&type=script&lang=js"
import style0 from "./HighSchool.vue?vue&type=style&index=0&id=1747a8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747a8fc",
  null
  
)

export default component.exports